import { NavLink, Outlet } from "react-router-dom";
import { Mail, Beaker, GitBranch, Eye, Clock } from "lucide-react";

const SUBTABS = [
  { to: "ab",       label: "A/B Lab",        icon: Beaker,    id: "email-ops-ab",       end: true },
  { to: "funnels",  label: "Funnels",        icon: GitBranch, id: "email-ops-funnels" },
  { to: "preview",  label: "Template Preview", icon: Eye,     id: "email-ops-preview" },
  { to: "jobs",     label: "Scheduled Jobs", icon: Clock,     id: "email-ops-jobs" },
];

export default function AdminEmailOps() {
  return (
    <div className="space-y-5" data-testid="admin-email-ops">
      {/* Hero header */}
      <div className="card p-5">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-[var(--ink)] text-white flex items-center justify-center flex-shrink-0">
            <Mail size={18} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="font-display font-extrabold text-xl tracking-tight text-[var(--ink)]">Email Operations</h2>
            <p className="text-[var(--ink-2)] text-xs mt-0.5">
              A/B experiments, conversion funnels, template previews, and scheduled jobs — all in one place.
            </p>
          </div>
        </div>

        {/* Subtab nav */}
        <div className="flex items-center gap-1 mt-4 -mb-1 overflow-x-auto">
          {SUBTABS.map((t) => (
            <NavLink
              key={t.id}
              to={t.to}
              end={t.end}
              data-testid={`nav-${t.id}`}
              className={({ isActive }) =>
                "flex items-center gap-2 px-3.5 py-2 rounded-lg text-sm font-semibold transition-all whitespace-nowrap " +
                (isActive
                  ? "bg-[var(--ink)] text-white"
                  : "text-[var(--ink-2)] hover:bg-[var(--bg)]")
              }
            >
              <t.icon size={14} />
              {t.label}
            </NavLink>
          ))}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
